<template>
    <div class="fw-my">
        <div class="fw-my-bg">
            <img src="./../../assets/home.png">
        </div>
        <div v-if="userType!=3">
            <div class="mendianname">
                <i class="el-icon-s-shop" style="font-size: 20px;color:#AAAAAA;"></i>
                <span style="font-size: 15px;color:#AAAAAA;margin-left: 23px">{{user.deptName}}</span>
                <span style="font-size: 15px;color:#AAAAAA;margin-left: 23px" @click="toMds">
                <i class="el-icon-arrow-down" style="font-size: 15px"></i>
            </span>
            </div>
        </div>
        <div v-if="userType==3">
            <div class="mendianname">
                <i class="el-icon-s-shop" style="font-size: 20px;color:#AAAAAA;"></i>
                <span style="font-size: 15px;color:#AAAAAA;margin-left: 23px">{{dgj.deptName}}</span>
                <span style="font-size: 15px;color:#AAAAAA;margin-left: 23px" @click="toMds">
                <i class="el-icon-arrow-down" style="font-size: 15px"></i>
            </span>
            </div>
            <div class="gwitem">
                <span class="gwitem-f">{{dgj.plabsName==null?'暂无':dgj.plabsName}}</span>
                <span class="gwitem-r">{{dgj.gradeName==null?'暂无':dgj.gradeName}}</span>
            </div>
        </div>
        <div class="my-menu">
            <div class="my-menu-item" style="border-right: #dddddd solid 1px;border-bottom: #dddddd solid 1px">
                <van-icon name="friends-o" class="vanicon"/>
                <span>编辑资料</span>
            </div>
            <div class="my-menu-item" style="border-bottom: #dddddd solid 1px" @click="loginout">
                <van-icon name="shield-o" class="vanicon"/>
                <span>安全退出</span>
            </div>
            <div class="my-menu-item" style="border-right: #dddddd solid 1px;" v-if="userType!=3" @click="toAccount">
                <van-icon name="setting-o" class="vanicon" />
                <span >账户设置</span>
            </div>
            <div class="my-menu-item" v-if="userType!=3" @click="toAddress">
                <van-icon name="location-o" class="vanicon" />
                <span >地址管理</span>
            </div>
            <div class="my-menu-item" style="border-right: #dddddd solid 1px;" v-if="userType==3">
            </div>
            <div class="my-menu-item" v-if="userType==3">
            </div>
        </div>
        <van-popup v-model="mdShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 55%;overflow:hidden;padding-bottom: 50px">
             <span class="md-bt">
                    <span>门店列表</span>
                    <i class="el-icon-close" @click="guanbi"></i>
             </span>
            <div class="md-items" v-if="userType!=3">
                <div>
                    <div class="md-item" v-for="md in mds">
                        <div class="fw-mduser">
                            <i class="el-icon-s-shop" style="font-size: 20px;color:#777777;margin-right: 8px"/>
                            <span style="margin-left: -50%">{{md.deptName}}</span>
                            <span class="jinruEmp" @click="jinruUser(md)">进入</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="md-items" v-if="userType==3">
                <div>
                    <div class="md-item" v-for="md in mds">
                        <div class="fw-mdemp">
                            <i class="el-icon-s-shop" style="font-size: 20px;color:#777777;margin-right: 8px"/>
                            <span>{{md.deptName}}</span>
                        </div>
                        <div class="fw-roles">
                            <div class="fw-role" v-if="md.firstLevel">
                                <span>{{md.firstStationName}} / {{md.firstLevelName}}</span>
                                <span class="jinru1" v-if="md.firstLevel==emp.gradeId">当前</span>
                                <span class="jinruEmp" v-if="md.firstLevel!=emp.gradeId"
                                      @click="jinruEmp(md,1)">切换</span>
                            </div>
                            <div class="fw-role" v-if="md.secondLevel">
                                <span>{{md.secondStationName}} / {{md.secondLevelName}}</span>
                                <span class="jinru1" v-if="md.secondLevel==emp.gradeId">当前</span>
                                <span class="jinruEmp" v-if="md.secondLevel!=emp.gradeId"
                                      @click="jinruEmp(md,2)">切换</span>
                            </div>
                            <div class="fw-role" v-if="md.thirdLevel">
                                <span>{{md.thirdStationName}} / {{md.thirdLevelName}}</span>
                                <span class="jinru1" v-if="md.thirdLevel==emp.gradeId">当前</span>
                                <span class="jinruEmp" v-if="md.thirdLevel!=emp.gradeId"
                                      @click="jinruEmp(md,3)">切换</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {delCookie, getCookie, setCookie} from "../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                deptId: '',
                fwUser: {},
                token: '',
                mds: [],
                user: {},
                emp: {},
                dgj: {},
                userType: '',
                mdShow: false
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.userType = this.fwUser.userType
            this.getInfo()
            this.getMds()
        },
        methods: {
            getInfo() {
                //查询总部/门店账号信息
                if (this.userType == 1 || this.userType == 2) {
                    this.getUserInfo()
                }
                //查询门店员工信息
                if (this.userType == 3) {
                    this.getEmpInfo()
                }
            },
            async getEmpInfo() {
                let data = {
                    token: this.token
                }
                let res = await this.$get("/fw/getFwEmpInfo", data)
                this.emp = res.emp
                this.dgj = res.dgj
            },
            async getUserInfo() {
                let data = {
                    token: this.token
                }
                let res = await this.$get("/fw/getFwUserInfo", data)
                this.user = res.user
            },
            async getMds() {
                //查询总部要切换的门店
                if (this.userType == 1) {
                    this.getUserMds()
                }
                //查询门店要切换的门店
                if (this.userType == 2) {
                    this.getUserMds()
                }
                //查询员工要切换的门店
                if (this.userType == 3) {
                    this.getEmpMds()
                }
            },
            async getEmpMds() {
                let data = {
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwEmpDeptList", data)
                this.mds = res.mds
            },
            async getUserMds() {
                let data = {
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwUserDeptList", data)
                this.mds = res.mds
            },
            toMds() {
                this.mdShow = true
            },

            //员工选择角色切换门店
            async jinruEmp(emp, station) {
                emp.station = station
                let res = await this.$post("/fw/fwSetEmp", emp)
                if (res.code == 200) {
                    setCookie('fwUser', JSON.stringify(res.fwUser), 30)
                    this.$notify({type: 'success', message: "切换成功"});
                    this.fwUser = JSON.parse(getCookie("fwUser"))
                    this.deptId = this.fwUser.deptId
                    this.token = this.fwUser.token
                    this.getInfo()
                    this.mdShow = false
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },

            async jinruUser(item) {
                delete item.expireTime
                delete item.createTime
                delete item.lastPwdResetTime
                if (!item.zhType){
                    delete item.zhType
                }
                let res = await this.$post("/fw/fwSetUser", item)
                if (res.code == 200) {
                    setCookie('fwUser', JSON.stringify(res.fwUser), 30)
                    location.reload();
                    // this.$notify({type: 'success', message: "切换成功"});
                    this.fwUser = JSON.parse(getCookie("fwUser"))
                    this.deptId = this.fwUser.deptId
                    this.token = this.fwUser.token
                    this.getInfo()
                    // this.mdShow = false
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },

            loginout() {
                delCookie("fwUser")
                this.$router.push('/login')
            },

            toAccount() {
                this.$router.push('/account')
            },
            toAddress() {
                this.$router.push('/address')
            },
            guanbi() {
                this.mdShow = false
            },
        },
    };
</script>

<style lang="scss" scoped>

    .fw-my {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-bottom: 49px;
    }

    .mendianname {
        display: flex;
        flex-direction: row;
        height: 42px;
        line-height: 41px;
        background-color: #ffffff;
        margin-bottom: 5px;
        border: #dddddd solid 1px;
        justify-content: center;
        align-items: center;
    }

    ::v-deep .el-input .el-input__inner {
        border-color: #ffffff !important;
        border-radius: 0px;
    }

    .gwitem {
        display: flex;
        flex-direction: row;
        height: 42px;
        line-height: 41px;
        background-color: #ffffff;
        margin-bottom: 5px;
        border: #dddddd solid 1px;
        justify-content: space-between;
        align-items: center;
    }

    .gwitem-f {
        width: 40%;
        border-right: #dddddd solid 1px;
        text-align: center;
        font-size: 13px;
    }

    .gwitem-r {
        width: 60%;
        text-align: center;
        font-size: 13px;
    }

    .my-menu {
        display: flex;
        flex-flow: row wrap;
        padding: 28px 16px;
    }

    .my-menu-item {
        flex: 1;
        box-sizing: border-box;
        height: 140px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: calc(50%);
        min-width: calc(50%);
        max-width: calc(50%);

        &:nth-child(2n + 2) {
            margin-right: 0;
        }
    }

    .my-menu-item span {
        font-size: 15px;
    }

    .vanicon {
        margin-bottom: 10px;
    }

    .md-bt {
        display: inline-block;
        font-size: 15px;
        border-bottom: #dddddd solid 1px;
        padding: 10px;
    }

    .qiehuan1 {
        padding: 5px;
    }

    .qiehuan {
        padding: 5px;
        background-color: #2b94ff;
        border-radius: 3px;
        color: #ffffff;
    }

    .md-items {
        display: flex;
        flex-direction: column;
        overflow: auto;
        height: 100%;
        padding-bottom: 30px;
    }

    .md-bt {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        font-size: 15px;
        border-bottom: #dddddd solid 1px;
        padding: 10px;
    }

    .md-item {
        width: 90%;
        margin: auto;
        padding: 8px 20px;
        font-size: 13px;
        display: flex;
        flex-direction: column;
        background-color: #eeeeee;
        margin-top: 10px;
        border-radius: 3px;
    }

    .fw-mduser {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .fw-mdemp {
        display: flex;
        align-items: center;
        padding-bottom: 3px;
        border-bottom: #dddddd solid 1px;
    }

    .fw-roles {
        display: flex;
        flex-direction: column;
        padding-top: 8px;
    }

    .fw-role {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 20px;
        margin: 3px 0px;
    }

    .jinruEmp {
        padding: 3px 8px;
        background-color: #2b94ff;
        border-radius: 3px;
        color: #ffffff;
    }

    .jinru1 {
        padding: 3px 8px;
    }

</style>
